import { getIpHomeAddress } from "~/api/api";
import {
	addLocalePrefix,
	isHomeRoutePath,
	isI18nLocaleRoute,
	LOCALE_REGION_COOKIE_KEY,
	parseLocaleSegmentFromPath,
	stripLocalePrefix,
	TW_REGION_SEGMENT,
} from "~/utils/i18n-locale-routes";
import { getRuntimeLocale } from "~/i18n/index";

const IP_REGION_CHECKED_KEY = "ip-locale-region-checked-v3";

function getCountryCode(res) {
	return res?.data?.data?.country_code || res?.data?.country_code || res?.country_code || "";
}

export default defineNuxtPlugin(nuxtApp => {
	let checking = false;

	const checkRouteRegion = async route => {
		if (!import.meta.client) return;
		if (!isI18nLocaleRoute(route.path)) return;
		if (getRuntimeLocale() === "en") return;
		if (!isHomeRoutePath(route.path)) return;
		if (checking) return;

		const localeRegionCookie = useCookie(LOCALE_REGION_COOKIE_KEY, {
			default: () => "",
			maxAge: 60 * 60 * 24 * 365,
			sameSite: "lax",
		});

		try {
			if (sessionStorage.getItem(IP_REGION_CHECKED_KEY)) return;
			sessionStorage.setItem(IP_REGION_CHECKED_KEY, "1");
		} catch {
			// Ignore storage errors.
		}

		checking = true;
		try {
			const res = await getIpHomeAddress();
			const countryCode = String(getCountryCode(res)).trim().toUpperCase();
			const isTw = countryCode === "TW";

			localeRegionCookie.value = isTw ? TW_REGION_SEGMENT : "";
			await syncPathWithRegion(route, localeRegionCookie.value);
		} catch (error) {
			console.error("IP region check failed", error);
		} finally {
			checking = false;
		}
	};

	nuxtApp.hook("app:mounted", async () => {
		await checkRouteRegion(useRoute());
	});

	const router = useRouter();
	router.afterEach(to => {
		void checkRouteRegion(to);
	});
});

async function syncPathWithRegion(route, region) {
	const segment = parseLocaleSegmentFromPath(route.path);
	const businessPath = stripLocalePrefix(route.path);

	if (!isHomeRoutePath(route.path)) return;

	if (region === TW_REGION_SEGMENT) {
		if (segment === TW_REGION_SEGMENT) return;
		const localizedPath = addLocalePrefix(businessPath, "zh-TW", { preferTw: true });
		if (localizedPath !== route.path) {
			await navigateTo({
				path: localizedPath,
				query: route.query,
				hash: route.hash,
				replace: true,
			});
		}
		return;
	}

	if (segment === TW_REGION_SEGMENT) {
		await navigateTo({
			path: businessPath,
			query: route.query,
			hash: route.hash,
			replace: true,
		});
	}
}
